/**
 * Words the help-center search treats specially. Edit freely -- the engine
 * (src/lib/searchEngine.js) reads these lists and nothing else is needed; run
 * `yarn test` afterwards, the search tests use real articles.
 *
 * CommonJS so plain Node (tests, scripts) can load it too.
 */

/**
 * Ways readers say the same thing. A query containing any entry of a group
 * also finds articles that use the others. Multi-word entries are matched as
 * phrases ("ongkos kirim"). Keep groups tight: an entry that is only sometimes
 * a synonym (e.g. "lama" for "terlambat") brings noise into every search.
 */
const synonyms = [
  // services
  ["pre order", "preorder", "po"],
  ["unique request", "ureq", "titip beli", "jastip"],
  ["ready stock", "ready"],
  ["friendship points", "friendship point", "poin", "point"],
  // money
  ["batal", "cancel", "cancelled"],
  ["refund", "pengembalian dana", "uang kembali", "dana kembali", "balik uang"],
  ["dp", "down payment", "uang muka"],
  ["lunas", "pelunasan", "full payment", "fullpay"],
  ["bayar", "pembayaran", "payment"],
  ["va", "virtual account"],
  ["qris", "qr"],
  ["kartu kredit", "credit card", "cc"],
  ["ecommerce", "e commerce", "marketplace"],
  ["rekening", "atm", "rekening bank"],
  ["voucher", "kupon", "kode promo"],
  ["telat", "terlambat"],
  // Not "hangus": a forfeited payment is a different question from an expired VA.
  ["expired", "kedaluwarsa", "kadaluarsa"],
  // shipping
  ["ongkir", "ongkos kirim", "biaya kirim", "shipping"],
  ["resi", "nomor resi", "tracking", "lacak", "awb"],
  ["kirim", "pengiriman", "dikirim", "shipment"],
  ["paket", "parcel", "package"],
  ["pickup", "ambil di toko", "store pickup"],
  // claims
  ["retur", "return", "tukar"],
  ["klaim", "komplain", "complain", "claim"],
  ["rusak", "cacat", "defect", "penyok", "pecah"],
  ["unboxing", "buka paket"],
  // channels
  ["cs", "customer service", "admin"],
  ["wa", "whatsapp", "whatsap", "watsap"],
  ["telepon", "telpon", "nelpon", "call"],
  ["toko", "store", "toko fisik", "offline store"],
  ["akun", "account"],
  ["password", "kata sandi", "sandi"]
];

/**
 * Words that carry no meaning in a help search: chat fillers, pronouns and
 * question frames ("Kyou, gimana dong caranya aku ..."). They are ignored
 * unless the whole query is made of them.
 */
const stopwords = [
  "aku", "saya", "kamu", "gue", "gw", "kak", "kakak", "min", "gan", "sis", "bang",
  "kyou", "halo", "hai", "hi", "tolong", "mohon",
  "ya", "yah", "yaa", "yuk", "dong", "sih", "deh", "nih", "kok", "lho", "loh", "kah", "toh",
  "aja", "saja", "juga", "lagi", "udah", "sudah", "kan", "nya",
  "gak", "ga", "nggak", "ngga", "enggak", "tidak", "bukan",
  "yang", "di", "ke", "dari", "dan", "atau", "untuk", "buat", "dengan", "sama", "pada", "dalam",
  "ini", "itu", "tuh", "apa", "apakah", "gimana", "bagaimana", "kenapa", "mengapa",
  "mau", "ingin", "pengen", "bisa", "boleh", "harus", "ada", "jadi",
  "the", "is", "a", "an", "of", "to", "how", "what", "can", "i"
];

module.exports = { synonyms, stopwords };
